import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';

import Chart from '../member/Chart';

const useStyles = makeStyles(
	{
		root: {
			width: '100%',
			height: '100%',
			border: '1px solid #979797',
			padding: '24px 20px 20px 20px'
		},
		content: {
			textAlign: 'left',
			padding: 0
		},
		cardTitleText: {
			color: '#5E6366',
			fontFamily: 'Graphik',
			fontSize: 15,
			fontWeight: 500,
			letterSpacing: 0,
		},
		barDiv: {
			marginTop: 35
		},
		percentageText: {
			color: '#5E6366',
			fontFamily: 'Graphik',
			fontSize: 24,
			fontWeight: 700,
			letterSpacing: 0,
			marginTop: 35,
		},
		barTitleText: {
			color: '#5E6366',
			fontFamily: 'Graphik',
			fontSize: 14,
			fontWeight: 400,
			letterSpacing: 0,
			marginTop: 35,
		}
	}
);

function makeLineOptions(options) {
	return {
		chart: {
			height: 250,
			align: 'left',
			marginRight: 0,
			spacingLeft: 0,
			spacingRight: 0
		},
		legend: {
			squareSymbol: true,
			symbolRadius: 0,
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'top',
			borderWidth: 0,
			y: -10,
        },
		tooltip: {
			enabled: false
		},
		credits: {
			enabled: false
		},
  		title: {
			text: options.title,
			align: 'left',
			style: {
				color: '#5E6366',
				fontFamily: 'Graphik',
				fontSize: 15,
				fontWeight: 600,
				letterSpacing: 0,
        	}
		},
		xAxis: {
			categories: options.xAxis
		},
		yAxis: {
			max: 100,
			title: {
				text: null
			}
    	},
		series: options.series,
		plotOptions: {
			series: {
				marker: {
					enabled: false
				}
			}
    	} 
	}
}

const LineChartCard = ( {options} ) => {
	const classes = useStyles();

	return (

		<Card className={classes.root}>
			<CardContent className={classes.content}>
				<Chart options={makeLineOptions(options)}/>	
        	</CardContent>
		</Card>
	)
}

export default LineChartCard;